import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

export function AuthButton({ children, ...rest }) {
    return (
        <Button
            variant="contained"
            color="secondary"
            fullWidth
            type="submit"
            size="large"
            {...rest}
        >
            {children}
        </Button>
    );
}

AuthButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    transparent: PropTypes.bool
};
